import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../App";
import {
  CDN_URL,
  formatDate,
  getInlineLoader,
  getPublishedItems,
  truncateText,
} from "../Helpers";
import PageHero from "../ones/PageHero";
import Footer from "../ones/Footer";
import CallToAction from "../ones/callToAction";

export default function GalleryLanding() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function init() {
      setReady(false);
      await appContext.getAllGallery();
      if (mounted) {
        setReady(true);
      }
    }

    init();

    return () => {
      mounted = false;
    };
  }, []);

  const publishedGallery = useMemo(() => {
    return getPublishedItems(appContext.allGallery);
  }, [appContext.allGallery]);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <PageHero
        title="Snapshots from AGS fieldwork, mapping delivery, and geospatial execution"
        description="Browse selected project imagery, field documentation, and moments from AGS operations across surveying, GIS, and aerial mapping assignments."
        badge="Gallery"
      />

      <section className="ags-section">
        <div className="container">
          {publishedGallery.length > 0 ? (
            <div className="row g-4">
              {publishedGallery.map((item, index) => (
                <div
                  className="col-md-6 col-xl-4"
                  key={item.uuid || index}
                  style={{minHeight: "500px"}}
                  data-aos="fade-up"
                  data-aos-delay={index * 40}
                >
                  <article className="ags-gallery-card h-100">
                    <div className="ags-gallery-card-media">
                      <img
                        src={`${CDN_URL}${item.photo}`}
                        alt={truncateText(item.description, 80) || "AGS gallery item"}
                      />
                    </div>
                    <div className="ags-gallery-card-body">
                      <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                        <span className="ags-gallery-chip">AGS </span>
                        <small className="text-muted">
                          {formatDate(item.dateCreated, true)}
                        </small>
                      </div>
                      <h5 className="font-bold mb-0">
                        {truncateText(item.description, 140)}
                      </h5>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          ) : (
            <div className="ags-empty-state text-center">
              <p className="ags-section-kicker mb-2">Gallery</p>
              <h3 className="font-bold mb-3">No published gallery items yet</h3>
              <p className="text-muted mb-0">
                Gallery updates will appear here as soon as they are published.
              </p>
            </div>
          )}
        </div>
      </section>

      <CallToAction />

      <Footer />
    </>
  );
}
